import { PHONE_LOOKUP_TYPE } from "../../app-consts/appConstants";
import { drw_endpoint_url } from "../api";
import { FetchBenefitsOptions } from "../types";

type FetchBenefitsParams = {
  appId: string;
  partnerCode: string;
};

export const createFetchBenefitsUrl = ({ appId, partnerCode }: FetchBenefitsParams) => {
  const endpoint = `${drw_endpoint_url}/api/omniapi/${appId}/partner/${partnerCode}/retrieveBenefits`;

  const queryParams = new URLSearchParams();
  const conversationId = localStorage.getItem("conversationId");
  if (conversationId) queryParams.append("conversationId", conversationId);

  return `${endpoint}${queryParams.toString() ? "?" + queryParams : ""}`;
};

export const createFetchBenefitsBody = (options: FetchBenefitsOptions) => {
  const {
    callId: fallbackCallId,
    details = {},
    guestFlow,
    jobId,
    lastName: optLastName,
    lookupType,
    partnerMemberId,
    phoneNumber,
    searchCallId,
    tollFreeNumber,
    transactionNumber,
    usageId,
    uuid,
    vin,
  } = options;

  const { firstName = null, lastName: detailsLastName, zip: zipCode = null, stateCode: stateCodeRaw } = details;

  const lastName = detailsLastName ?? optLastName ?? null;
  const stateCode = stateCodeRaw ?? null;
  const callId = searchCallId ?? fallbackCallId ?? null;

  return {
    partnerMemberId,
    transactionNumber,
    vin,
    firstName,
    lastName,
    zipCode,
    stateCode,
    phoneNumber,
    incomingNumber: phoneNumber,
    tollFreeNumber,
    jobId,
    lookupType,
    callId,
    usageId,
    guestFlow,
    searchCallId,
    appointmentNumber: searchCallId,
    uuid,
    ...(PHONE_LOOKUP_TYPE.includes(lookupType) && { searchBy: phoneNumber }),
  };
};

export const sanitizeLicensePlateForPayload = (licensePlate: string) => licensePlate.replace(/[^0-9a-zA-Z]/g, "");
